import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { environment } from '@pp/environment';

import { AUTH_KEY, STATUS } from './auth.constants';
import { AuthStore } from './auth.store';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  readonly #store = inject(AuthStore);
  readonly #router = inject(Router);

  activeStatusCheck() {
    if (environment.useMocks) {
      this.#store.setActivationStatus(true);
      this.#store.setAuthStatus(true);
      return true;
    }
    const isActive = this.#store.isActive();
    const is2faEnabled = this.#store.is2faEnabled();
    if (isActive && is2faEnabled) {
      return true;
    }

    return this.statusCheck();
  }

  inactiveStatusCheck() {
    const isActive = this.#store.isActive();
    const is2faEnabled = this.#store.is2faEnabled();
    if (isActive || is2faEnabled) {
      return true;
    }

    return this.notActiveStatusCheck();
  }

  statusCheck(): boolean {
    const status = globalThis.localStorage.getItem(STATUS);
    const isActive = status ? status === 'active' : false;
    if (!isActive) {
      this.#store.setActivationStatus(false);
      this.#router.navigate(['/signin']);

      return false;
    }

    this.#store.setActivationStatus(true);
    return true;
  }

  notActiveStatusCheck(): boolean {
    const status = globalThis.localStorage.getItem(STATUS);
    const isActive = status ? status === 'active' : false;
    if (isActive) {
      this.#store.setActivationStatus(true);
      this.#router.navigate(['/']);

      return false;
    }

    this.#store.setActivationStatus(false);

    return true;
  }

  signedInCheck() {
    const authorized = this.#store.isAuthorized();
    if (authorized) {
      return true;
    }

    return this.check();
  }

  signedOutCheck() {
    const authorized = this.#store.isAuthorized();
    if (!authorized) {
      return true;
    }

    return !this.check();
  }

  check() {
    const authKey = globalThis.localStorage.getItem(AUTH_KEY);
    if (!authKey) {
      this.#store.setAuthStatus(false);
      this.#router.navigate(['/signin']);

      return false;
    }
    this.#store.setAuthStatus(true);

    return true;
  }

  logout(): void {
    this.#store.logout();
  }
}
